import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 435.1 430.3"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M324.1 14.1c49.8-49.8 148.2 44.6 96.4 96.4l-20.8 20.8-96.4-96.4zm-42.4 41.4 96.4 96.4-227.2 227.2-.8.8-.3-.3L0 430.3l54.1-146.5-.3-.3zM140.6 334.8l38.3-38.3-41.8-41.8L98.9 293l-37 75z" }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "pencil"}) } }